import type { MouseEvent } from 'react';

export function isSecondaryActionClick(event: MouseEvent): boolean {
  return event.ctrlKey || event.metaKey || event.type === 'contextmenu';
}
